import {
  SEGMENT_FIELD_TYPES,
  SEGMENT_TYPES,
  URL_MAX_LENGTH,
  IMAGE_POSITION_OPTIONS,
  SLIDER_ANIMATION_OPTIONS,
  MEGA_MENU_STYLE_OPTIONS,
  MEGA_MENU_CONTENT_OPTIONS,
  MEGA_MENU_DISPLAY_OPTIONS,
  MEGA_MENU_HIERARCHY_OPTIONS,
  STYLE_OPTIONS,
  HERO_CTA_ICON_OPTIONS,
  field,
  visualStyleProperty,
  globalColorProperties,
  commonSegment
} from "./segmentRegistryCore";

const HERO_CTA_FONT_WEIGHT_OPTIONS = Object.freeze([
  { value: "", label: "Actual / heredado" },
  { value: 300, label: "Liviano (300)" },
  { value: 400, label: "Normal (400)" },
  { value: 500, label: "Medio (500)" },
  { value: 600, label: "Semibold (600)" },
  { value: 700, label: "Negrita (700)" },
  { value: 800, label: "Extra negrita (800)" },
  { value: 900, label: "Black (900)" },
]);
const NAVBAR_FONT_WEIGHT_OPTIONS = Object.freeze(
  HERO_CTA_FONT_WEIGHT_OPTIONS.filter((option) => option.value !== ""),
);

function megaMenuVisualField(path, label, group, type = SEGMENT_FIELD_TYPES.COLOR, extra = {}) {
  return field(`navigation.megaMenuVisual.${path}`, type, {
    label,
    uiGroup: "design",
    megaMenuGroup: group,
    explicitVisual: true,
    ...extra,
  });
}

function megaMenuVisualProperties() {
  const color = (path, label, group) => megaMenuVisualField(path, label, group);
  return [
    color("surface.backgroundColor", "Fondo del mega menú", "Superficies"),
    color("surface.borderColor", "Borde del mega menú", "Superficies"),
    megaMenuVisualField("surface.boxShadow", "Sombra del mega menú", "Superficies", SEGMENT_FIELD_TYPES.TEXT, { maxLength: 300 }),
    megaMenuVisualField("surface.borderWidth", "Grosor del borde del mega menú (px)", "Superficies", SEGMENT_FIELD_TYPES.NUMBER, { limits: { min: 0, max: 4, step: 1 } }),
    megaMenuVisualField("surface.borderRadius", "Radio inferior del mega menú (px)", "Superficies", SEGMENT_FIELD_TYPES.NUMBER, { limits: { min: 0, max: 64, step: 1 } }),
    color("introSurface.backgroundColor", "Fondo del bloque destacado", "Superficies"),
    color("introSurface.borderColor", "Borde del bloque destacado", "Superficies"),

    color("eyebrow.color", "Texto superior · color", "Encabezado"),
    color("eyebrow.introColor", "Texto superior · color sobre bloque destacado", "Encabezado"),
    color("title.color", "Título · color", "Encabezado"),
    color("title.introColor", "Título · color sobre bloque destacado", "Encabezado"),
    color("description.color", "Descripción · color", "Encabezado"),
    color("description.introColor", "Descripción · color sobre bloque destacado", "Encabezado"),
    color("categoriesTitle.color", "Título principal de categorías · color", "Encabezado"),
    color("categoriesSubtitle.color", "Subtítulo de categorías · color", "Encabezado"),
    color("sortLabel.color", "Texto auxiliar de categorías · color", "Encabezado"),
    color("latestLabel.color", "Título de últimos agregados · color", "Encabezado"),

    color("allItemsButton.textColor", "Ver todos · texto", "Botón Ver todos"),
    color("allItemsButton.backgroundColor", "Ver todos · fondo", "Botón Ver todos"),
    color("allItemsButton.borderColor", "Ver todos · borde", "Botón Ver todos"),
    color("allItemsButton.hoverTextColor", "Ver todos · texto hover", "Botón Ver todos"),
    color("allItemsButton.hoverBackgroundColor", "Ver todos · fondo hover", "Botón Ver todos"),
    color("allItemsButton.hoverBorderColor", "Ver todos · borde hover", "Botón Ver todos"),
    color("introAllItemsButton.textColor", "Ver todos destacado · texto", "Botón Ver todos"),
    color("introAllItemsButton.backgroundColor", "Ver todos destacado · fondo", "Botón Ver todos"),
    color("introAllItemsButton.borderColor", "Ver todos destacado · borde", "Botón Ver todos"),
    color("introAllItemsButton.hoverTextColor", "Ver todos destacado · texto hover", "Botón Ver todos"),
    color("introAllItemsButton.hoverBackgroundColor", "Ver todos destacado · fondo hover", "Botón Ver todos"),
    color("introAllItemsButton.hoverBorderColor", "Ver todos destacado · borde hover", "Botón Ver todos"),

    color("statsChip.textColor", "Estadísticas · texto", "Categorías"),
    color("statsChip.backgroundColor", "Estadísticas · fondo", "Categorías"),
    color("statsChip.borderColor", "Estadísticas · borde", "Categorías"),
    color("introStatsChip.textColor", "Estadísticas destacadas · texto", "Categorías"),
    color("introStatsChip.backgroundColor", "Estadísticas destacadas · fondo", "Categorías"),
    color("introStatsChip.borderColor", "Estadísticas destacadas · borde", "Categorías"),
    color("showcaseStatsText.color", "Estadísticas en Showcase · texto", "Categorías"),
    color("categoryRow.labelColor", "Categoría · texto", "Categorías"),
    color("categoryRow.countColor", "Categoría · cantidad", "Categorías"),
    color("categoryRow.iconColor", "Categoría · flecha", "Categorías"),
    color("categoryRow.backgroundColor", "Categoría · fondo", "Categorías"),
    color("categoryRow.borderColor", "Categoría · borde", "Categorías"),
    color("categoryRow.hoverBackgroundColor", "Categoría · fondo hover", "Categorías"),
    color("categoryRow.hoverBorderColor", "Categoría · borde hover", "Categorías"),
    color("subcategory.textColor", "Subcategoría · texto", "Categorías"),
    color("subcategory.backgroundColor", "Subcategoría · fondo", "Categorías"),
    color("subcategory.hoverTextColor", "Subcategoría · texto hover", "Categorías"),
    color("subcategory.hoverBackgroundColor", "Subcategoría · fondo hover", "Categorías"),
    color("categoryPill.textColor", "Pill de categoría · texto", "Categorías"),
    color("categoryPill.backgroundColor", "Pill de categoría · fondo", "Categorías"),
    color("categoryPill.borderColor", "Pill de categoría · borde", "Categorías"),
    color("categoryPill.hoverTextColor", "Pill de categoría · texto hover", "Categorías"),
    color("categoryPill.hoverBackgroundColor", "Pill de categoría · fondo hover", "Categorías"),
    color("categoryPill.hoverBorderColor", "Pill de categoría · borde hover", "Categorías"),
    color("divider.color", "Divisor entre bloques · color", "Categorías"),

    color("previewCard.backgroundColor", "Card del mega menú · fondo", "Productos/cards"),
    color("previewCard.borderColor", "Card del mega menú · borde", "Productos/cards"),
    color("previewCard.hoverBorderColor", "Card del mega menú · borde hover", "Productos/cards"),
    megaMenuVisualField("previewCard.boxShadow", "Card del mega menú · sombra", "Productos/cards", SEGMENT_FIELD_TYPES.TEXT, { maxLength: 300 }),
    megaMenuVisualField("previewCard.hoverBoxShadow", "Card del mega menú · sombra hover", "Productos/cards", SEGMENT_FIELD_TYPES.TEXT, { maxLength: 300 }),
    color("previewCard.categoryTextColor", "Card · categoría", "Productos/cards"),
    color("previewCard.titleTextColor", "Card · título", "Productos/cards"),
    color("previewCard.descriptionTextColor", "Card · descripción", "Productos/cards"),
    color("previewCard.imageBackgroundColor", "Card · fondo de imagen", "Productos/cards"),
    color("latestItem.textColor", "Último agregado · texto", "Productos/cards"),
    color("latestItem.backgroundColor", "Último agregado · fondo", "Productos/cards"),
    color("latestItem.borderColor", "Último agregado · borde", "Productos/cards"),
    color("latestItem.hoverTextColor", "Último agregado · texto hover", "Productos/cards"),
    color("latestItem.hoverBackgroundColor", "Último agregado · fondo hover", "Productos/cards"),
    color("latestItem.hoverBorderColor", "Último agregado · borde hover", "Productos/cards"),

    color("loading.spinnerColor", "Spinner mientras carga", "Estados"),
    color("loading.textColor", "Texto mientras carga", "Estados"),
    color("empty.backgroundColor", "Estado vacío · fondo", "Estados"),
    color("empty.borderColor", "Estado vacío · borde", "Estados"),
    color("empty.textColor", "Estado vacío · texto", "Estados"),
    color("error.backgroundColor", "Error · fondo", "Estados"),
    color("error.borderColor", "Error · borde", "Estados"),
    color("error.textColor", "Error · texto", "Estados"),
    color("error.iconColor", "Error · icono", "Estados"),
  ];
}


function heroCtaStyleProperties(stylePath, label) {
  return [
    field(`${stylePath}.textColor`, SEGMENT_FIELD_TYPES.COLOR, {
      label: `${label} · texto`,
      uiGroup: "design",
    }),
    field(`${stylePath}.backgroundColor`, SEGMENT_FIELD_TYPES.COLOR, {
      label: `${label} · fondo`,
      uiGroup: "design",
    }),
    field(`${stylePath}.backgroundOpacity`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · opacidad del fondo`,
      limits: { min: 0, max: 1, step: 0.05 },
      uiGroup: "design",
    }),
    field(`${stylePath}.hoverTextColor`, SEGMENT_FIELD_TYPES.COLOR, {
      label: `${label} · texto al pasar el mouse`,
      uiGroup: "design",
    }),
    field(`${stylePath}.hoverBackgroundColor`, SEGMENT_FIELD_TYPES.COLOR, {
      label: `${label} · fondo al pasar el mouse`,
      uiGroup: "design",
    }),
    field(`${stylePath}.hoverBackgroundOpacity`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · opacidad hover`,
      limits: { min: 0, max: 1, step: 0.05 },
      uiGroup: "design",
    }),
    field(`${stylePath}.borderColor`, SEGMENT_FIELD_TYPES.COLOR, {
      label: `${label} · borde`,
      uiGroup: "design",
    }),
    field(`${stylePath}.borderWidth`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · ancho de borde (px)`,
      limits: { min: 0, max: 16, step: 0.5 },
      uiGroup: "design",
    }),
    field(`${stylePath}.borderRadius`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · radio de borde (px)`,
      limits: { min: 0, max: 999, step: 1 },
      uiGroup: "design",
    }),
    field(`${stylePath}.fontSize`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · tamaño de texto (px)`,
      limits: { min: 8, max: 72, step: 1 },
      uiGroup: "design",
    }),
    field(`${stylePath}.fontWeight`, SEGMENT_FIELD_TYPES.SELECT, {
      label: `${label} · peso tipográfico`,
      options: HERO_CTA_FONT_WEIGHT_OPTIONS,
      uiGroup: "design",
    }),
    field(`${stylePath}.minWidth`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · ancho mínimo (px)`,
      limits: { min: 0, max: 600, step: 1 },
      uiGroup: "design",
    }),
    field(`${stylePath}.minHeight`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · alto mínimo (px)`,
      limits: { min: 0, max: 160, step: 1 },
      uiGroup: "design",
    }),
    field(`${stylePath}.paddingX`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · padding horizontal (px)`,
      limits: { min: 0, max: 64, step: 1 },
      uiGroup: "design",
    }),
    field(`${stylePath}.paddingY`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · padding vertical (px)`,
      limits: { min: 0, max: 48, step: 1 },
      uiGroup: "design",
    }),
    field(`${stylePath}.shadowColor`, SEGMENT_FIELD_TYPES.COLOR, {
      label: `${label} · color de sombra`,
      uiGroup: "design",
    }),
    field(`${stylePath}.shadowOpacity`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · opacidad de sombra`,
      limits: { min: 0, max: 1, step: 0.05 },
      uiGroup: "design",
    }),
    field(`${stylePath}.shadowX`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · sombra X (px)`,
      limits: { min: -100, max: 100, step: 1 },
      uiGroup: "design",
    }),
    field(`${stylePath}.shadowY`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · sombra Y (px)`,
      limits: { min: -100, max: 100, step: 1 },
      uiGroup: "design",
    }),
    field(`${stylePath}.shadowBlur`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · blur de sombra (px)`,
      limits: { min: 0, max: 160, step: 1 },
      uiGroup: "design",
    }),
    field(`${stylePath}.shadowSpread`, SEGMENT_FIELD_TYPES.NUMBER, {
      label: `${label} · spread de sombra (px)`,
      limits: { min: -80, max: 80, step: 1 },
      uiGroup: "design",
    }),
  ];
}


const NAVBAR_DESKTOP_LINK_DEFAULTS = Object.freeze({
  textColor: "#5B5D73",
  backgroundColor: "transparent",
  borderColor: "transparent",
  hoverTextColor: "#19242F",
  hoverBackgroundColor: "rgba(0,0,0,.04)",
  hoverBorderColor: "transparent",
  activeTextColor: "#19242F",
  activeBackgroundColor: "rgba(0,0,0,.045)",
  activeBorderColor: "transparent",
  activeIndicatorColor: "#F35A3A",
  endIconColor: "#5B5D73",
});
const NAVBAR_MOBILE_LINK_DEFAULTS = Object.freeze({
  textColor: "#1A1A2E",
  backgroundColor: "transparent",
  borderColor: "transparent",
  hoverTextColor: "#1A1A2E",
  hoverBackgroundColor: "#EEF0F5",
  hoverBorderColor: "transparent",
  activeTextColor: "#19242F",
  activeBackgroundColor: "rgba(0,0,0,.045)",
  activeBorderColor: "rgba(26,26,46,.09)",
  activeIndicatorColor: "#F35A3A",
  endIconColor: "#5B5D73",
  fontSize: 16,
  fontWeight: 800,
  activeFontWeight: 900,
  minHeight: 52,
  borderRadius: 18,
  focusColor: "#F35A3A",
});
const NAVBAR_ACTION_DEFAULTS = Object.freeze({
  color: "#19242F",
  backgroundColor: "transparent",
  borderColor: "transparent",
  hoverColor: "#19242F",
  hoverBackgroundColor: "#EEF0F5",
  hoverBorderColor: "#F35A3A",
  badgeBackgroundColor: "#F35A3A",
  badgeTextColor: "#FFFFFF",
  avatarBackgroundColor: "#19242F",
  avatarTextColor: "#FFFFFF",
  mutedTextColor: "#5B5D73",
});

function navbarColorField(path, label, defaultValue) {
  return field(path, SEGMENT_FIELD_TYPES.COLOR, {
    label,
    uiGroup: "design",
    explicitVisual: true,
    defaultValue,
    maxLength: 100,
  });
}

function navbarLinkStyleProperties(prefix, label, defaults) {
  const d = defaults || NAVBAR_DESKTOP_LINK_DEFAULTS;
  const base = [
    navbarColorField(`${prefix}textColor`, `${label} · texto`, d.textColor),
    navbarColorField(`${prefix}backgroundColor`, `${label} · fondo`, d.backgroundColor),
    navbarColorField(`${prefix}borderColor`, `${label} · borde`, d.borderColor),
    navbarColorField(`${prefix}hoverTextColor`, `${label} · texto hover`, d.hoverTextColor),
    navbarColorField(`${prefix}hoverBackgroundColor`, `${label} · fondo hover`, d.hoverBackgroundColor),
    navbarColorField(`${prefix}hoverBorderColor`, `${label} · borde hover`, d.hoverBorderColor),
    navbarColorField(`${prefix}activeTextColor`, `${label} · texto activo`, d.activeTextColor),
    navbarColorField(`${prefix}activeBackgroundColor`, `${label} · fondo activo`, d.activeBackgroundColor),
    navbarColorField(`${prefix}activeBorderColor`, `${label} · borde activo`, d.activeBorderColor),
    navbarColorField(`${prefix}activeIndicatorColor`, `${label} · indicador activo`, d.activeIndicatorColor),
    navbarColorField(`${prefix}endIconColor`, `${label} · ícono`, d.endIconColor),
  ];
  if (!String(prefix).includes("mobileStyle")) return base;
  return [
    ...base,
    navbarColorField(`${prefix}focusColor`, `${label} · foco`, d.focusColor || "#F35A3A"),
    field(`${prefix}fontSize`, SEGMENT_FIELD_TYPES.NUMBER, { label: `${label} · tamaño de texto (px)`, uiGroup: "design", explicitVisual: true, defaultValue: d.fontSize ?? 16, limits: { min: 8, max: 40, step: 1 } }),
    field(`${prefix}fontWeight`, SEGMENT_FIELD_TYPES.SELECT, { label: `${label} · peso`, uiGroup: "design", explicitVisual: true, defaultValue: d.fontWeight ?? 800, options: NAVBAR_FONT_WEIGHT_OPTIONS }),
    field(`${prefix}activeFontWeight`, SEGMENT_FIELD_TYPES.SELECT, { label: `${label} · peso activo`, uiGroup: "design", explicitVisual: true, defaultValue: d.activeFontWeight ?? 900, options: NAVBAR_FONT_WEIGHT_OPTIONS }),
    field(`${prefix}minHeight`, SEGMENT_FIELD_TYPES.NUMBER, { label: `${label} · alto mínimo (px)`, uiGroup: "design", explicitVisual: true, defaultValue: d.minHeight ?? 52, limits: { min: 32, max: 96, step: 1 } }),
    field(`${prefix}borderRadius`, SEGMENT_FIELD_TYPES.NUMBER, { label: `${label} · redondeado (px)`, uiGroup: "design", explicitVisual: true, defaultValue: d.borderRadius ?? 18, limits: { min: 0, max: 80, step: 1 } }),
  ];
}

function navbarActionStyleProperties(prefix, label, defaults = NAVBAR_ACTION_DEFAULTS) {
  return [
    navbarColorField(`${prefix}color`, `${label} · texto/ícono`, defaults.color),
    navbarColorField(`${prefix}backgroundColor`, `${label} · fondo`, defaults.backgroundColor),
    navbarColorField(`${prefix}borderColor`, `${label} · borde`, defaults.borderColor),
    navbarColorField(`${prefix}hoverColor`, `${label} · texto/ícono hover`, defaults.hoverColor),
    navbarColorField(`${prefix}hoverBackgroundColor`, `${label} · fondo hover`, defaults.hoverBackgroundColor),
    navbarColorField(`${prefix}hoverBorderColor`, `${label} · borde hover`, defaults.hoverBorderColor),
    navbarColorField(`${prefix}badgeBackgroundColor`, `${label} · badge fondo`, defaults.badgeBackgroundColor),
    navbarColorField(`${prefix}badgeTextColor`, `${label} · badge texto`, defaults.badgeTextColor),
    navbarColorField(`${prefix}avatarBackgroundColor`, `${label} · avatar fondo`, defaults.avatarBackgroundColor),
    navbarColorField(`${prefix}avatarTextColor`, `${label} · avatar texto`, defaults.avatarTextColor),
    navbarColorField(`${prefix}mutedTextColor`, `${label} · texto secundario`, defaults.mutedTextColor),
  ];
}

function navbarAccountDrawerStyleProperties(prefix, label) {
  return [
    navbarColorField(`${prefix}containerBackgroundColor`, `${label} · contenedor fondo`, "#FFFFFF"),
    navbarColorField(`${prefix}containerBorderColor`, `${label} · contenedor borde`, "rgba(26,26,46,.09)"),
    navbarColorField(`${prefix}primaryTextColor`, `${label} · nombre`, "#1A1A2E"),
    navbarColorField(`${prefix}secondaryTextColor`, `${label} · email`, "#5B5D73"),
    navbarColorField(`${prefix}avatarBackgroundColor`, `${label} · avatar fondo`, "#19242F"),
    navbarColorField(`${prefix}avatarTextColor`, `${label} · avatar texto`, "#FFFFFF"),
    navbarColorField(`${prefix}logoutColor`, `${label} · cerrar sesión texto`, "#1A1A2E"),
    navbarColorField(`${prefix}logoutBackgroundColor`, `${label} · cerrar sesión fondo`, "#FFFFFF"),
    navbarColorField(`${prefix}logoutBorderColor`, `${label} · cerrar sesión borde`, "rgba(26,26,46,.09)"),
    navbarColorField(`${prefix}logoutHoverColor`, `${label} · cerrar sesión texto hover`, "#1A1A2E"),
    navbarColorField(`${prefix}logoutHoverBackgroundColor`, `${label} · cerrar sesión fondo hover`, "#EEF0F5"),
    navbarColorField(`${prefix}logoutHoverBorderColor`, `${label} · cerrar sesión borde hover`, "rgba(26,26,46,.09)"),
    navbarColorField(`${prefix}logoutFocusColor`, `${label} · cerrar sesión foco`, "#F35A3A"),
  ];
}

function navbarSurfaceStyleProperties(prefix, label, defaults = {}) {
  return [
    navbarColorField(`${prefix}backgroundColor`, `${label} · fondo`, defaults.backgroundColor || "#FFFFFF"),
    navbarColorField(`${prefix}borderColor`, `${label} · borde`, defaults.borderColor || "rgba(26,26,46,.09)"),
    field(`${prefix}boxShadow`, SEGMENT_FIELD_TYPES.TEXT, {
      label: `${label} · sombra CSS`,
      uiGroup: "design",
      defaultValue: defaults.boxShadow || "none",
      maxLength: 300,
      explicitVisual: true,
    }),
  ];
}

function navbarLogoSurfaceProperties(prefix, label, defaults = {}) {
  return [
    navbarColorField(`${prefix}backgroundColor`, `${label} · fondo`, defaults.backgroundColor || "transparent"),
    navbarColorField(`${prefix}borderColor`, `${label} · borde`, defaults.borderColor || "transparent"),
    field(`${prefix}boxShadow`, SEGMENT_FIELD_TYPES.TEXT, { label: `${label} · sombra CSS`, uiGroup: "design", explicitVisual: true, defaultValue: defaults.boxShadow || "none", maxLength: 300 }),
    field(`${prefix}paddingX`, SEGMENT_FIELD_TYPES.NUMBER, { label: `${label} · padding horizontal`, uiGroup: "design", explicitVisual: true, defaultValue: defaults.paddingX ?? 0, limits: { min: 0, max: 64, step: 0.5 } }),
    field(`${prefix}paddingY`, SEGMENT_FIELD_TYPES.NUMBER, { label: `${label} · padding vertical`, uiGroup: "design", explicitVisual: true, defaultValue: defaults.paddingY ?? 0, limits: { min: 0, max: 48, step: 0.5 } }),
    field(`${prefix}borderRadius`, SEGMENT_FIELD_TYPES.NUMBER, { label: `${label} · redondeado`, uiGroup: "design", explicitVisual: true, defaultValue: defaults.borderRadius ?? 0, limits: { min: 0, max: 160, step: 0.5 } }),
  ];
}


function navbarMobileIconButtonProperties(prefix, label) {
  return [
    navbarColorField(`${prefix}color`, `${label} · ícono`, "#19242F"),
    navbarColorField(`${prefix}backgroundColor`, `${label} · fondo`, "#FFFFFF"),
    navbarColorField(`${prefix}borderColor`, `${label} · borde`, "rgba(26,26,46,.09)"),
    navbarColorField(`${prefix}hoverColor`, `${label} · ícono hover`, "#19242F"),
    navbarColorField(`${prefix}hoverBackgroundColor`, `${label} · fondo hover`, "#EEF0F5"),
    navbarColorField(`${prefix}hoverBorderColor`, `${label} · borde hover`, "rgba(26,26,46,.09)"),
    navbarColorField(`${prefix}focusColor`, `${label} · foco`, "#F35A3A"),
    field(`${prefix}size`, SEGMENT_FIELD_TYPES.NUMBER, { label: `${label} · tamaño (px)`, uiGroup: "design", explicitVisual: true, defaultValue: 42, limits: { min: 32, max: 72, step: 1 } }),
  ];
}

function navbarMobileCatalogItemProperties(prefix, label) {
  return [
    navbarColorField(`${prefix}textColor`, `${label} · texto`, "#1A1A2E"),
    navbarColorField(`${prefix}mutedTextColor`, `${label} · texto secundario`, "#5B5D73"),
    navbarColorField(`${prefix}hoverBackgroundColor`, `${label} · fondo hover`, "#EEF0F5"),
    navbarColorField(`${prefix}focusColor`, `${label} · foco`, "#F35A3A"),
  ];
}

function navbarTopbarStyleProperties(prefix = "navigation.topbarStyle.") {
  return [
    navbarColorField(`${prefix}backgroundColor`, "Franja superior · fondo", "#19242F"),
    navbarColorField(`${prefix}borderColor`, "Franja superior · borde", "rgba(255,255,255,.1)"),
    navbarColorField(`${prefix}textColor`, "Franja superior · texto", "#FFFFFF"),
    navbarColorField(`${prefix}iconColor`, "Franja superior · íconos", "#F35A3A"),
    navbarColorField(`${prefix}socialIconColor`, "Franja superior · redes", "#FFFFFF"),
    navbarColorField(`${prefix}socialHoverBackgroundColor`, "Franja superior · fondo hover redes", "rgba(255,255,255,.1)"),
  ];
}


const NAVBAR_ELEMENT_TARGETS = Object.freeze({
  "@navbar.logo": Object.freeze({
    kind: "image",
    label: "Logo",
    fieldPath: "theme.logoUrl",
    mobileVariantPath: "theme.compactLogoUrl",
    showPath: "navigation.showLogo",
    chips: ["Desktop", "Mobile"],
    logoAppearance: {
      groups: [
        {
          label: "Escritorio",
          colorPath: "navigation.logoColor",
          sizePath: "navigation.logoMaxHeight",
          assetPaths: ["theme.logoUrl"],
          surfacePrefix: "navigation.logoSurfaceStyle.desktop.",
          min: 20,
          max: 120,
          step: 1,
        },
        {
          label: "Celular",
          colorPath: "navigation.mobile.logoColor",
          sizePath: "navigation.mobile.logoMaxHeight",
          assetPaths: ["theme.compactLogoUrl", "theme.logoUrl"],
          surfacePrefix: "navigation.logoSurfaceStyle.mobile.",
          min: 20,
          max: 96,
          step: 1,
        },
      ],
    },
  }),
  "business.name": Object.freeze({
    kind: "text",
    label: "Nombre del negocio",
    colorPathByDevice: { desktop: "navigation.businessNameStyle.desktop.color", mobile: "navigation.businessNameStyle.mobile.color" },
  }),
  "navigation.homeLabel": Object.freeze({
    kind: "button",
    label: "Inicio",
    labelPath: "navigation.homeLabel",
    urlPath: "navigation.homeUrl",
    stylePrefixByDevice: { desktop: "navigation.links.home.desktopStyle.", mobile: "navigation.links.home.mobileStyle." },
    chips: ["Desktop", "Mobile", "Link"],
  }),
  "navigation.aboutLabel": Object.freeze({
    kind: "button",
    label: "Sobre nosotros",
    labelPath: "navigation.aboutLabel",
    urlPath: "navigation.aboutUrl",
    showPath: "navigation.showAboutLink",
    stylePrefixByDevice: { desktop: "navigation.links.about.desktopStyle.", mobile: "navigation.links.about.mobileStyle." },
    chips: ["Desktop", "Mobile", "Link"],
  }),
  "navigation.highlightsLabel": Object.freeze({
    kind: "button",
    label: "Diferenciales",
    labelPath: "navigation.highlightsLabel",
    urlPath: "navigation.highlightsUrl",
    showPath: "navigation.showHighlightsLink",
    stylePrefixByDevice: { desktop: "navigation.links.highlights.desktopStyle.", mobile: "navigation.links.highlights.mobileStyle." },
    chips: ["Desktop", "Mobile", "Link"],
  }),
  "navigation.productsLabel": Object.freeze({
    kind: "button",
    label: "Productos o servicios",
    labelPath: "navigation.productsLabel",
    urlPath: "navigation.productsUrl",
    showPath: "navigation.showProductsLink",
    megaMenu: true,
    stylePrefixByDevice: { desktop: "navigation.links.catalog.desktopStyle.", mobile: "navigation.links.catalog.mobileStyle." },
    chips: ["Desktop", "Mobile", "Mega menú"],
  }),
  "navigation.contactLabel": Object.freeze({
    kind: "button",
    label: "Contacto",
    labelPath: "navigation.contactLabel",
    urlPath: "navigation.contactUrl",
    showPath: "navigation.showContactLink",
    stylePrefixByDevice: { desktop: "navigation.links.contact.desktopStyle.", mobile: "navigation.links.contact.mobileStyle." },
    chips: ["Desktop", "Mobile", "Link"],
  }),
  "navigation.loginLabel": Object.freeze({
    kind: "button",
    label: "Acceso clientes",
    labelPath: "navigation.loginLabel",
    urlPath: "navigation.loginUrl",
    showPath: "navigation.showCustomerAccess",
    extraPaths: ["navigation.accountLabel"],
    stylePrefixByDevice: { desktop: "navigation.loginStyles.desktop.", mobile: "navigation.loginStyles.mobile." },
    chips: ["Desktop", "Mobile", "Link"],
  }),
  "navigation.accountLabel": Object.freeze({
    kind: "button",
    label: "Cuenta",
    labelPath: "navigation.accountLabel",
    stylePrefixByDevice: { desktop: "navigation.accountStyles.desktop.", mobile: "navigation.accountStyles.mobile." },
    chips: ["Desktop", "Mobile", "Cuenta"],
  }),
  "navigation.cartLabel": Object.freeze({
    kind: "button",
    label: "Carrito",
    labelPath: "navigation.cartLabel",
    showPath: "navigation.showCart",
    stylePrefixByDevice: { desktop: "navigation.cartStyles.desktop.", mobile: "navigation.cartStyles.mobile." },
    chips: ["Desktop", "Mobile", "Carrito"],
  }),
  "@navbar.mobile-menu": Object.freeze({
    kind: "navbar-mobile",
    label: "Menú móvil",
    fieldPrefix: "navigation.mobile.",
    extraPaths: [
      "navigation.showSocialLinks",
      "navigation.menuAriaLabel",
      "navigation.closeMenuAriaLabel",
      "navigation.mobile.drawerStyle.backgroundColor",
      "navigation.mobile.drawerStyle.borderColor",
      "navigation.businessNameStyle.drawer.color",
    ],
    extraPrefixes: [
      "navigation.links.home.mobileStyle.",
      "navigation.links.catalog.mobileStyle.",
      "navigation.links.about.mobileStyle.",
      "navigation.links.highlights.mobileStyle.",
      "navigation.links.contact.mobileStyle.",
      "navigation.loginStyles.mobile.",
      "navigation.accountStyles.mobile.",
      "navigation.accountStyles.drawer.",
      "navigation.loginStyles.drawer.",
      "navigation.cartStyles.mobile.",
    ],
    chips: ["Mobile"],
  }),
  "@navbar.buttons-manager": Object.freeze({
    kind: "collection-manager",
    label: "Administrar botones",
    collectionPath: "navigation.buttons",
    chips: ["Desktop", "Mobile"],
  }),
});

const NAVBAR_SHELL_PROPERTY_PATHS = Object.freeze([
  "navigation.style",
  "navigation.borderRadius",
  "navigation.shellStyle.backgroundColor",
  "navigation.shellStyle.borderColor",
  "navigation.shellStyle.boxShadow",
  "navigation.barStyle.backgroundColor",
  "navigation.barStyle.borderColor",
  "navigation.barStyle.boxShadow",
  "navigation.topbarStyle.backgroundColor",
  "navigation.topbarStyle.borderColor",
  "navigation.topbarStyle.textColor",
  "navigation.topbarStyle.iconColor",
  "navigation.topbarStyle.socialIconColor",
  "navigation.topbarStyle.socialHoverBackgroundColor",
  "navigation.showCart",
  "navigation.cartAriaLabel",
]);


const HERO_ELEMENT_TARGETS = Object.freeze({
  "@hero.slides-manager": Object.freeze({
    kind: "collection-manager",
    label: "Slider de portada",
    collectionPath: "hero.slides",
    editorMode: "slides",
    chips: ["Slider"],
  }),
  "@hero.rotating-phrases": Object.freeze({
    kind: "collection-manager",
    label: "Frases rotativas",
    collectionPath: "hero.rotatingPhrases",
    editorMode: "phrases",
    chips: ["Texto dinámico"],
  }),
});

const HERO_SHELL_PROPERTY_PATHS = Object.freeze([
  "hero.autoplay",
  "hero.intervalMs",
  "hero.animation",
  "hero.contentHorizontalAlign",
  "hero.contentVerticalAlign",
  "hero.overlay",
]);

const structureSegments = {
  [SEGMENT_TYPES.NAVBAR]: commonSegment({
    id: SEGMENT_TYPES.NAVBAR,
    visibilityPath: "sections.showNavbar",
    // Navbar no usa visualStyle.colors/backgroundImageUrl como fuente viva.
    // Sus superficies y elementos tienen propietarios explícitos en navigation.*.
    shellVisualBackground: false,
    shellVisualPalette: false,
    elementEditingReady: true,
    elementTargets: NAVBAR_ELEMENT_TARGETS,
    shellPropertyPaths: NAVBAR_SHELL_PROPERTY_PATHS,
    properties: [
      field("sections.showNavbar", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar encabezado",
      }),
      field("navigation.style", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Estilo del encabezado",
        options: STYLE_OPTIONS,
      }),
      field("navigation.borderRadius", SEGMENT_FIELD_TYPES.NUMBER, {
        label: "Redondeado de la barra",
        limits: { min: 0, max: 48, step: 1 },
        uiGroup: "design",
        control: "slider",
        nullable: false,
        defaultValue: 18,
        helperText: "Controla la forma exterior del encabezado. No modifica botones ni menús desplegables.",
        resetLabel: "Restablecer a 18 px",
      }),
      ...navbarSurfaceStyleProperties("navigation.shellStyle.", "Fondo exterior", { boxShadow: "0 8px 30px rgba(20,25,35,.05)" }),
      ...navbarSurfaceStyleProperties("navigation.barStyle.", "Superficie de barra", { boxShadow: "none" }),
      ...navbarTopbarStyleProperties(),
      ...navbarLogoSurfaceProperties("navigation.logoSurfaceStyle.desktop.", "Logo · escritorio"),
      ...navbarLogoSurfaceProperties("navigation.logoSurfaceStyle.mobile.", "Logo · celular"),
      ...navbarLogoSurfaceProperties("navigation.logoSurfaceStyle.drawer.", "Logo · drawer"),
      navbarColorField("navigation.businessNameStyle.desktop.color", "Nombre del negocio · escritorio", "#19242F"),
      navbarColorField("navigation.businessNameStyle.mobile.color", "Nombre del negocio · celular", "#19242F"),
      navbarColorField("navigation.businessNameStyle.drawer.color", "Nombre del negocio · drawer", "#1A1A2E"),
      ...navbarLinkStyleProperties("navigation.links.home.desktopStyle.", "Inicio · escritorio", NAVBAR_DESKTOP_LINK_DEFAULTS),
      ...navbarLinkStyleProperties("navigation.links.home.mobileStyle.", "Inicio · celular", NAVBAR_MOBILE_LINK_DEFAULTS),
      ...navbarLinkStyleProperties("navigation.links.catalog.desktopStyle.", "Catálogo/Carta · escritorio", NAVBAR_DESKTOP_LINK_DEFAULTS),
      ...navbarLinkStyleProperties("navigation.links.catalog.mobileStyle.", "Catálogo/Carta · celular", NAVBAR_MOBILE_LINK_DEFAULTS),
      ...navbarLinkStyleProperties("navigation.links.about.desktopStyle.", "Sobre nosotros · escritorio", NAVBAR_DESKTOP_LINK_DEFAULTS),
      ...navbarLinkStyleProperties("navigation.links.about.mobileStyle.", "Sobre nosotros · celular", NAVBAR_MOBILE_LINK_DEFAULTS),
      ...navbarLinkStyleProperties("navigation.links.highlights.desktopStyle.", "Diferenciales · escritorio", NAVBAR_DESKTOP_LINK_DEFAULTS),
      ...navbarLinkStyleProperties("navigation.links.highlights.mobileStyle.", "Diferenciales · celular", NAVBAR_MOBILE_LINK_DEFAULTS),
      ...navbarLinkStyleProperties("navigation.links.contact.desktopStyle.", "Contacto · escritorio", NAVBAR_DESKTOP_LINK_DEFAULTS),
      ...navbarLinkStyleProperties("navigation.links.contact.mobileStyle.", "Contacto · celular", NAVBAR_MOBILE_LINK_DEFAULTS),
      ...navbarActionStyleProperties("navigation.loginStyles.desktop.", "Login · escritorio"),
      ...navbarActionStyleProperties("navigation.loginStyles.mobile.", "Login · celular"),
      ...navbarActionStyleProperties("navigation.loginStyles.drawer.", "Login · drawer"),
      ...navbarActionStyleProperties("navigation.accountStyles.desktop.", "Cuenta · escritorio"),
      ...navbarActionStyleProperties("navigation.accountStyles.mobile.", "Cuenta · celular"),
      ...navbarAccountDrawerStyleProperties("navigation.accountStyles.drawer.", "Cuenta · drawer"),
      ...navbarActionStyleProperties("navigation.cartStyles.desktop.", "Carrito · escritorio"),
      ...navbarActionStyleProperties("navigation.cartStyles.mobile.", "Carrito · celular"),
      ...navbarSurfaceStyleProperties("navigation.mobile.shellStyle.", "Navbar móvil · fondo exterior", { boxShadow: "0 8px 30px rgba(20,25,35,.05)" }),
      ...navbarSurfaceStyleProperties("navigation.mobile.barStyle.", "Navbar móvil · superficie de barra", { boxShadow: "none" }),
      ...navbarSurfaceStyleProperties("navigation.mobile.drawerStyle.", "Drawer móvil · cuerpo", { backgroundColor: "#EEF0F5", borderColor: "rgba(26,26,46,.09)", boxShadow: "none" }),
      ...navbarSurfaceStyleProperties("navigation.mobile.drawerHeaderStyle.", "Drawer móvil · encabezado", { backgroundColor: "#EEF0F5", borderColor: "rgba(26,26,46,.09)", boxShadow: "none" }),
      ...navbarMobileIconButtonProperties("navigation.mobile.openButtonStyle.", "Abrir menú"),
      ...navbarMobileIconButtonProperties("navigation.mobile.closeButtonStyle.", "Cerrar menú"),
      ...navbarSurfaceStyleProperties("navigation.mobile.catalogPanelStyle.", "Panel de catálogo móvil", { backgroundColor: "#FFFFFF", borderColor: "rgba(26,26,46,.09)", boxShadow: "none" }),
      ...navbarMobileCatalogItemProperties("navigation.mobile.catalogItemStyle.", "Opciones del catálogo móvil"),
      field("navigation.mobile.itemGap", SEGMENT_FIELD_TYPES.NUMBER, {
        label: "Drawer móvil · separación entre opciones (px)",
        limits: { min: 0, max: 32, step: 0.5 },
        uiGroup: "design",
        control: "slider",
        nullable: false,
        defaultValue: 5.2,
        resetLabel: "Restablecer a 5,2 px",
      }),
      field("navigation.showLogo", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar logo en la barra",
      }),
      field("navigation.logoColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Logo · color SVG en escritorio",
        editable: false,
      }),
      field("navigation.logoMaxHeight", SEGMENT_FIELD_TYPES.NUMBER, {
        label: "Logo · alto máximo en escritorio (px)",
        limits: { min: 20, max: 120, step: 1 },
        editable: false,
      }),
      field("navigation.mobile.logoColor", SEGMENT_FIELD_TYPES.COLOR, {
        label: "Logo · color SVG en celular",
        editable: false,
      }),
      field("navigation.mobile.logoMaxHeight", SEGMENT_FIELD_TYPES.NUMBER, {
        label: "Logo · alto máximo en celular (px)",
        limits: { min: 20, max: 96, step: 1 },
        uiGroup: "design",
        editable: false,
      }),
      field("navigation.homeLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Inicio",
        maxLength: 80,
      }),
      field("navigation.aboutLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Sobre nosotros",
        maxLength: 100,
      }),
      field("navigation.highlightsLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Por qué elegirnos",
        maxLength: 100,
      }),
      field("navigation.productsLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Productos o servicios",
        maxLength: 80,
      }),
      field("navigation.allProductsLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Botón del mega menú",
        maxLength: 100,
      }),
      field("navigation.megaMenuStyle", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Estilo del mega menú",
        options: MEGA_MENU_STYLE_OPTIONS,
        uiGroup: "behavior",
      }),
      field("navigation.megaMenuContent", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Contenido del mega menú",
        options: MEGA_MENU_CONTENT_OPTIONS,
        uiGroup: "behavior",
      }),
      field("navigation.megaMenuDisplay", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Qué mostrar",
        options: MEGA_MENU_DISPLAY_OPTIONS,
        uiGroup: "behavior",
      }),
      field("navigation.megaMenuHierarchy", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Orden de categorías",
        options: MEGA_MENU_HIERARCHY_OPTIONS,
        uiGroup: "behavior",
      }),
      ...megaMenuVisualProperties(),
      field("navigation.showMegaMenuIntro", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar bloque destacado del mega menú",
      }),
      field("navigation.megaMenuEyebrow", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto superior del mega menú",
        maxLength: 120,
      }),
      field("navigation.megaMenuTitle", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título del mega menú",
        maxLength: 180,
      }),
      field("navigation.megaMenuDescription", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Descripción del mega menú",
        maxLength: 500,
      }),
      field("navigation.showMegaMenuStats", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar cantidades en el bloque destacado",
      }),
      field("navigation.megaMenuCategoriesSubtitle", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto debajo del título de categorías",
        maxLength: 220,
      }),
      field("navigation.megaMenuSortLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto auxiliar de categorías",
        maxLength: 120,
      }),
      field("navigation.showMegaMenuLatest", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar últimos agregados",
      }),
      field("navigation.megaMenuLatestLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título de últimos agregados",
        maxLength: 120,
      }),
      field("navigation.loadingCategoriesText", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto mientras carga el mega menú",
        maxLength: 180,
      }),
      field("navigation.emptyCategoriesText", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto si no hay categorías",
        maxLength: 220,
      }),
      field("navigation.categoriesErrorText", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto si falla el mega menú",
        maxLength: 220,
      }),
      field("navigation.contactLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Contacto",
        maxLength: 80,
      }),
      field("navigation.loginLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Acceso de clientes",
        maxLength: 100,
      }),
      field("navigation.accountLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Descripción accesible de la cuenta",
        maxLength: 100,
      }),
      field("navigation.buttons", SEGMENT_FIELD_TYPES.COLLECTION, {
        label: "Botones de la navbar",
        navbarButtons: true,
        limits: { maxItems: 8 },
        item: {
          fields: [
            { key: "id", type: SEGMENT_FIELD_TYPES.TEXT, maxLength: 100 },
            { key: "label", label: "Texto del botón", type: SEGMENT_FIELD_TYPES.TEXT, maxLength: 80 },
            {
              key: "behavior",
              label: "Comportamiento",
              type: SEGMENT_FIELD_TYPES.SELECT,
              defaultValue: "section",
              options: [
                { value: "section", label: "Deslizar a una sección" },
                { value: "link", label: "Abrir un link" },
                { value: "mega-menu", label: "Desplegar mega menú" },
              ],
            },
            { key: "target", label: "Destino", type: SEGMENT_FIELD_TYPES.URL, maxLength: URL_MAX_LENGTH },
            {
              key: "megaMenuContent",
              label: "Contenido del mega menú",
              type: SEGMENT_FIELD_TYPES.SELECT,
              defaultValue: "inherit",
              options: [
                { value: "inherit", label: "Usar configuración general" },
                ...MEGA_MENU_CONTENT_OPTIONS,
              ],
            },
            {
              key: "megaMenuDisplay",
              label: "Qué mostrar",
              type: SEGMENT_FIELD_TYPES.SELECT,
              defaultValue: "inherit",
              options: [
                { value: "inherit", label: "Usar configuración general" },
                ...MEGA_MENU_DISPLAY_OPTIONS,
              ],
            },
            {
              key: "megaMenuHierarchy",
              label: "Jerarquía",
              type: SEGMENT_FIELD_TYPES.SELECT,
              defaultValue: "inherit",
              options: [
                { value: "inherit", label: "Usar configuración general" },
                ...MEGA_MENU_HIERARCHY_OPTIONS,
              ],
            },
          ],
        },
      }),
      field("navigation.homeUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino de Inicio",
        maxLength: URL_MAX_LENGTH,
        destinationPicker: true,
      }),
      field("navigation.aboutUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino de Sobre nosotros",
        maxLength: URL_MAX_LENGTH,
        destinationPicker: true,
      }),
      field("navigation.highlightsUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino de Por qué elegirnos",
        maxLength: URL_MAX_LENGTH,
        destinationPicker: true,
      }),
      field("navigation.productsUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino de Productos o servicios",
        maxLength: URL_MAX_LENGTH,
        destinationPicker: true,
      }),
      field("navigation.contactUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino de Contacto",
        maxLength: URL_MAX_LENGTH,
        destinationPicker: true,
      }),
      field("navigation.loginUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino del acceso de clientes",
        maxLength: URL_MAX_LENGTH,
      }),
      field("navigation.showAboutLink", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar enlace Sobre nosotros",
      }),
      field("navigation.showHighlightsLink", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar enlace Por qué elegirnos",
      }),
      field("navigation.showProductsLink", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar enlace Productos",
      }),
      field("navigation.showContactLink", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar enlace Contacto",
      }),
      field("navigation.showCart", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar carrito",
      }),
      field("navigation.showCustomerAccess", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar acceso de clientes",
      }),
      field("navigation.showSocialLinks", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar redes sociales",
      }),
      field("navigation.menuAriaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Descripción accesible para abrir el menú",
        maxLength: 140,
      }),
      field("navigation.closeMenuAriaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Descripción accesible para cerrar el menú",
        maxLength: 140,
      }),
      field("navigation.cartAriaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Descripción accesible del carrito",
        maxLength: 140,
      }),
      field("business.name", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Nombre del negocio",
        maxLength: 140,
        shared: true,
      }),
      field("theme.logoUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Logo de la barra",
        maxLength: URL_MAX_LENGTH,
      }),
      field("theme.compactLogoUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Logo de la barra en celular",
        maxLength: URL_MAX_LENGTH,
      }),
    ],
  }),
  [SEGMENT_TYPES.HERO]: commonSegment({
    id: SEGMENT_TYPES.HERO,
    visibilityPath: "sections.showHero",
    elementEditingReady: true,
    elementTargets: HERO_ELEMENT_TARGETS,
    shellPropertyPaths: HERO_SHELL_PROPERTY_PATHS,
    properties: [
      field("sections.showHero", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar portada",
      }),
      field("hero.eyebrow", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto superior",
        maxLength: 180,
      }),
      field("hero.title", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Título principal",
        maxLength: 220,
      }),
      field("hero.subtitle", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Texto de apoyo",
        maxLength: 900,
      }),
      field("hero.primaryCtaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Botón principal",
        maxLength: 100,
      }),
      field("hero.primaryCtaUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino del botón principal",
        maxLength: URL_MAX_LENGTH,
        destinationPicker: true,
      }),
      field("hero.primaryCtaRequiresProducts", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "El botón principal requiere catálogo",
      }),
      field("hero.primaryCtaShowIcon", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar ícono en el botón principal",
        uiGroup: "behavior",
      }),
      field("hero.primaryCtaIcon", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Ícono del botón principal",
        options: HERO_CTA_ICON_OPTIONS,
        uiGroup: "behavior",
      }),
      ...heroCtaStyleProperties("hero.primaryCtaStyle", "Botón principal"),
      field("hero.secondaryCtaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Botón secundario",
        maxLength: 100,
      }),
      field("hero.secondaryCtaUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino del botón secundario",
        maxLength: URL_MAX_LENGTH,
        destinationPicker: true,
      }),
      field("hero.secondaryCtaRequiresProducts", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "El botón secundario requiere catálogo",
      }),
      field("hero.secondaryCtaShowIcon", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar ícono en el botón secundario",
        uiGroup: "behavior",
      }),
      field("hero.secondaryCtaIcon", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Ícono del botón secundario",
        options: HERO_CTA_ICON_OPTIONS,
        uiGroup: "behavior",
      }),
      ...heroCtaStyleProperties("hero.secondaryCtaStyle", "Botón secundario"),
      field("hero.imageUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Imagen principal",
        maxLength: URL_MAX_LENGTH,
      }),
      field("hero.imagePosition", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Posición de la imagen",
        options: IMAGE_POSITION_OPTIONS,
      }),
      field("hero.autoplay", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Avanzar slider automáticamente",
        uiGroup: "behavior",
      }),
      field("hero.intervalMs", SEGMENT_FIELD_TYPES.NUMBER, {
        label: "Velocidad · tiempo entre slides (ms)",
        defaultValue: 6500,
        uiGroup: "behavior",
        limits: { min: 2000, max: 15000, step: 500 },
      }),
      field("hero.animation", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Animación del slider",
        options: SLIDER_ANIMATION_OPTIONS,
        defaultValue: "slide",
        uiGroup: "behavior",
      }),
      field("hero.contentHorizontalAlign", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Posición horizontal de los textos",
        options: [
          { value: "left", label: "Izquierda" },
          { value: "center", label: "Centro" },
          { value: "right", label: "Derecha" },
        ],
        uiGroup: "behavior",
      }),
      field("hero.contentVerticalAlign", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Posición vertical de los textos",
        options: [
          { value: "top", label: "Arriba" },
          { value: "center", label: "Centro" },
          { value: "bottom", label: "Abajo" },
        ],
        uiGroup: "behavior",
      }),
      field("hero.overlay", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Capa sobre la imagen",
        maxLength: 600,
      }),
      field("hero.rotatingPhrases", SEGMENT_FIELD_TYPES.COLLECTION, {
        label: "Frases rotativas",
        limits: { maxItems: 12 },
        item: {
          type: SEGMENT_FIELD_TYPES.TEXT,
          maxLength: 180,
        },
      }),
      field("hero.slides", SEGMENT_FIELD_TYPES.COLLECTION, {
        label: "Imágenes de portada",
        limits: { maxItems: 6 },
        item: {
          fields: [
            { key: "url", label: "Imagen", type: SEGMENT_FIELD_TYPES.IMAGE, maxLength: URL_MAX_LENGTH },
            { key: "alt", label: "Texto alternativo", type: SEGMENT_FIELD_TYPES.TEXT, maxLength: 220 },
            { key: "title", label: "Título", type: SEGMENT_FIELD_TYPES.TEXT, maxLength: 220 },
            { key: "subtitle", label: "Subtítulo", type: SEGMENT_FIELD_TYPES.TEXTAREA, maxLength: 700 },
            { key: "position", label: "Posición de la imagen", type: SEGMENT_FIELD_TYPES.SELECT, options: IMAGE_POSITION_OPTIONS },
          ],
        },
      }),
      ...globalColorProperties(),
      visualStyleProperty(SEGMENT_TYPES.HERO),
    ],
  }),
};

export default structureSegments;
